/**
 * LeanIQ Offer Junip — optional initials avatars
 * Replaces Junip face icons with customer initials (e.g. "Tim C" → "TC").
 */
(function () {
  function initialsFromName(name) {
    var parts = String(name || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return '';
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  function initialsFromAvatar(avatar) {
    var img = avatar.querySelector('.junip-avatar-image');
    if (img && img.alt) {
      var match = img.alt.match(/Avatar for\s+(.+)/i);
      if (match && match[1]) {
        return match[1].trim().replace(/\s+/g, '').slice(0, 3).toUpperCase();
      }
    }

    var root = avatar.closest('.junip-customer-container, .junip-review-customer');
    var nameEl = root && root.querySelector('.junip-customer-name');
    return initialsFromName(nameEl && nameEl.textContent);
  }

  function convertAvatar(avatar) {
    if (!avatar || avatar.getAttribute('data-liq-initials') === '1') return;

    var initials = initialsFromAvatar(avatar) || '?';
    var badge = avatar.querySelector('.liq-junip-initials');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'liq-junip-initials';
      badge.setAttribute('aria-hidden', 'true');
      avatar.appendChild(badge);
    }
    badge.textContent = initials;
    avatar.classList.add('liq-junip-avatar--initials');
    avatar.setAttribute('data-liq-initials', '1');
  }

  function convertRoot(root) {
    if (!root) return;
    root.querySelectorAll('.junip-avatar').forEach(convertAvatar);
  }

  function init(root) {
    if (!root || root.getAttribute('data-liq-junip-initials-ready') === '1') return;
    root.setAttribute('data-liq-junip-initials-ready', '1');

    convertRoot(root);

    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function () {
      convertRoot(root);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('[data-liq-junip].is-avatar-initials').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-liq-junip].is-avatar-initials')
      : null;
    if (section) init(section);
  });
})();
